import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import { IFlowData } from 'src/components/ui/Form/types';

import { IFilter, IFilterData } from './types';

const FILTER_URL = 'api/v1/filter-elements';

export const fetchFiltersListRequest = async ({ page, size, ...data }: IFlowData): Promise<IFilterData | null> => {
  try {
    const res = await axios.post(FILTER_URL, data, { params: { page, size } });
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch filters");
    return null;
  }
};

export const createFilterRequest = async (data: Partial<IFilter>): Promise<Partial<IFilter>> => {
  return axios.put(FILTER_URL, data);
};

export const updateFilterRequest = async ({ id, name, ...data }: Partial<IFilter>): Promise<Partial<IFilter>> => {
  return axios.post(`${FILTER_URL}/${id}`, data);
};

export const deleteFilterRequest = async (id: string | number): Promise<void> => {
  return axios.delete(`${FILTER_URL}/${id}`);
};

export const fetchFiltersDictRequest = async (): Promise<IFilter[]> => {
  try {
    const res = await axios.get(FILTER_URL);
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch filters");
    return [];
  }
};
